import { useState } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Sidebar from "@/components/layout/Sidebar";
import Topbar from "@/components/layout/Topbar";
import { Sheet, SheetContent } from "@/components/ui/sheet";

const TITLES = [
  { match: "/dashboard", title: "Dashboard" },
  { match: "/crm/empresas", title: "Empresas" },
  { match: "/crm/empresa", title: "Ficha de empresa" },
  { match: "/crm/contactos", title: "Contactos" },
  { match: "/crm/proveedores", title: "Proveedores" },
  { match: "/proyectos", title: "Proyectos" },
  { match: "/presupuestos", title: "Presupuestos" },
  { match: "/proyecto", title: "Proyecto" },
  { match: "/tareas", title: "Mis tareas" },
  { match: "/horas", title: "Registro de horas" },
  { match: "/tesoreria/gastos-fijos", title: "Gastos Fijos" },
  { match: "/portal/mi-ficha", title: "Mi ficha" },
  { match: "/portal/vacaciones", title: "Vacaciones y ausencias" },
  { match: "/portal/nominas", title: "Nóminas" },
  { match: "/portal/agenda", title: "Mi agenda" },
  { match: "/portal/festivos", title: "Festivos" },
  { match: "/rrhh/equipo", title: "Equipo" },
  { match: "/rrhh/registro-horario", title: "Registro Horario" },
  { match: "/rrhh/nominas", title: "Nóminas" },
  { match: "/rrhh/vacaciones", title: "Solicitudes de vacaciones" },
  { match: "/rrhh/calendario", title: "Calendario de equipo" },
  { match: "/rrhh/festivos", title: "Festivos" },
  { match: "/usuarios", title: "Usuarios" },
  { match: "/permisos", title: "Matriz de permisos" },
];

export default function AppLayout() {
  const { user, loading } = useAuth();
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("sidebar_collapsed") === "1");
  const location = useLocation();

  const toggleCollapsed = () => setCollapsed((c) => {
    localStorage.setItem("sidebar_collapsed", !c ? "1" : "0");
    return !c;
  });

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;

  const title = (TITLES.find((t) => location.pathname.startsWith(t.match)) || { title: "Grabarte" }).title;

  return (
    <div className="h-screen flex overflow-hidden bg-background">
      <div className="hidden lg:block h-full">
        <Sidebar collapsed={collapsed} onToggleCollapse={toggleCollapsed} />
      </div>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="p-0 w-60 border-0 [&>button]:text-white">
          <Sidebar onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onMenu={() => setOpen(true)} title={title} />
        <main className="flex-1 overflow-y-auto">
          <div className="p-4 sm:p-6 lg:p-8 max-w-[1400px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
